import React from 'react';
import {Col, Input, Row} from "reactstrap";
import TextLabel from "../../../../../Controls/TextLabel.mjs";

const G = window.glob;

const MailEditorSubject = class extends React.Component {
	constructor(props) {
		super(props);
		const m = props.message || {};
		this.state = {
			message: m,
			value: m.subject || ''
		};
		this.onChange = this.onChange.bind(this);
	}
	onChange = (v) => {
		v = v.target.value || '';
		const m = this.props.getter();
		m.subject = v;
		this.setState( { value: v, message: m });
		this.props.setter( m );
	};
	render() {
		return(
			<Row className={ this.props.error ? 'textinput error': 'textinput'}>
				<Col className={"nomobile"}>
					<TextLabel value={"Subject"} />
				</Col>
				<Col>
					<Input
						placeholder={ G.label('Subject') }
						type="text"
						value={ this.state.value }
						onChange={ this.onChange }
					/>
				</Col>
			</Row>
		)
	}
};

export default MailEditorSubject;
